import { persistState } from '@storeon/localstorage'
import { PERSIST_STATE_KEY } from 'Config'
import { createStoreon, StoreonModule, StoreonStore } from 'storeon'

import { CookieStorage } from './CookieStorage'
import {
  Events as SessionEvents,
  KEY as SESSION_KEY,
  sessionModule,
  State as SessionState,
} from './Session'
import {
  Events as StagingAuthEvents,
  KEY as STAGING_AUTH_KEY,
  stagingAuthModule,
  State as StagingAuthState,
} from './StagingAuth'

type State = SessionState & StagingAuthState
type Events = SessionEvents & StagingAuthEvents

type Store = StoreonStore<State, Events>

let storeInstance: Store | null = null

function createStore(): Store {
  if (storeInstance) return storeInstance

  const modules: Array<StoreonModule<State, Events> | false> = [
    sessionModule,
    stagingAuthModule,
    persistState([SESSION_KEY, STAGING_AUTH_KEY], {
      key: PERSIST_STATE_KEY,
      storage: CookieStorage,
    }),
  ]

  storeInstance = createStoreon<State, Events>(modules)

  return storeInstance
}

export const store = createStore()
export type { Store }
